/**
 * @generated SignedSource<<c20b51993d2a42be5c40e4fb23513210>>
 * @relayHash 0e2ff3e32406276d823f5080dc7f9714
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 54a10e60e2a0c15ce92471d6e08870349218fb356a74754f5961430a595b415b

import type { ConcreteRequest } from 'relay-runtime';
export type ContentHeaderUnifiedQuery$variables = {
  contentId: string;
  embeddedContentRender?: string | null;
  isMarkdownModeEnabled?: boolean | null;
  limit?: number | null;
  spaceKey?: string | null;
  status?: ReadonlyArray<string | null> | null;
  useNewContentTopper?: boolean | null;
  versionOverride?: number | null;
};
export type ContentHeaderUnifiedQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly contentProperties: {
        readonly latest: {
          readonly generatedBy: string | null;
          readonly isMarkdownMode?: boolean | null;
        } | null;
      } | null;
      readonly emojiTitlePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly history: {
        readonly createdBy: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
        readonly createdDate: string | null;
        readonly lastOwnedBy: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
        readonly ownedBy: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly metadata: {
        readonly frontend: {
          readonly coverPictureWidth?: string | null;
          readonly fabricEditorSupported: boolean | null;
        } | null;
        readonly lastModifiedDate: string | null;
        readonly sourceTemplateEntityId: string | null;
      };
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly space: {
        readonly homepageId: string | null;
        readonly id: string | null;
        readonly name: string | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
      readonly version: {
        readonly by: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly message: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly contentContributors: {
    readonly count: number | null;
    readonly isCurrentUserContributor: boolean | null;
    readonly isOwnerContributor: boolean | null;
    readonly nodes: ReadonlyArray<{
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly space: {
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly header: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
      } | null;
      readonly headings: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null>;
    } | null;
    readonly theme: {
      readonly themeKey: string | null;
    } | null;
  } | null;
};
export type ContentHeaderUnifiedQuery = {
  response: ContentHeaderUnifiedQuery$data;
  variables: ContentHeaderUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "embeddedContentRender"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isMarkdownModeEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v8 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v9 = [
  {
    "kind": "Variable",
    "name": "embeddedContentRender",
    "variableName": "embeddedContentRender"
  },
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  },
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = {
  "kind": "ScalarField",
  "name": "subType"
},
v13 = {
  "kind": "ScalarField",
  "name": "title"
},
v14 = {
  "kind": "ScalarField",
  "name": "status"
},
v15 = {
  "kind": "ScalarField",
  "name": "key"
},
v16 = {
  "kind": "ScalarField",
  "name": "value"
},
v17 = {
  "kind": "ScalarField",
  "name": "number"
},
v18 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v10/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          (v17/*: any*/)
        ]
      }
    ]
  }
],
v19 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v20 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v21 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v23 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v24 = [
  (v11/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/)
],
v25 = {
  "alias": "emojiTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v26 = {
  "condition": "useNewContentTopper",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "pageTitlePublished",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "page-title-property-published"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v18/*: any*/),
      "storageKey": "properties(key:\"page-title-property-published\")"
    }
  ]
},
v27 = {
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "editor"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(key:\"editor\")"
},
v28 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "homepageId"
    }
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "message"
},
v30 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v31 = {
  "kind": "ScalarField",
  "name": "when"
},
v32 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v33 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        },
        {
          "condition": "isMarkdownModeEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isMarkdownMode"
            }
          ]
        }
      ]
    }
  ]
},
v34 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "sourceTemplateEntityId"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "coverPictureWidth"
            }
          ]
        }
      ]
    }
  ]
},
v35 = [
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  }
],
v36 = {
  "kind": "ScalarField",
  "name": "count"
},
v37 = {
  "kind": "ScalarField",
  "name": "isCurrentUserContributor"
},
v38 = {
  "kind": "ScalarField",
  "name": "isOwnerContributor"
},
v39 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "concreteType": "Theme",
      "kind": "LinkedField",
      "name": "theme",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "themeKey"
        }
      ]
    },
    {
      "concreteType": "LookAndFeel",
      "kind": "LinkedField",
      "name": "lookAndFeel",
      "plural": false,
      "selections": [
        {
          "concreteType": "MapOfStringToString",
          "kind": "LinkedField",
          "name": "headings",
          "plural": true,
          "selections": [
            (v15/*: any*/),
            (v16/*: any*/)
          ]
        },
        {
          "concreteType": "ContentLookAndFeel",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "concreteType": "ContainerLookAndFeel",
              "kind": "LinkedField",
              "name": "header",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "background"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundAttachment"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundBlendMode"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundClip"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundColor"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundImage"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundOrigin"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundPosition"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundRepeat"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundSize"
                },
                {
                  "kind": "ScalarField",
                  "name": "borderRadius"
                },
                {
                  "kind": "ScalarField",
                  "name": "padding"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v40 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v11/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentHeaderUnifiedQuery",
    "selections": [
      {
        "args": (v9/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v19/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v24/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v24/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "lastOwnedBy",
                    "plural": false,
                    "selections": (v24/*: any*/)
                  }
                ]
              },
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": (v24/*: any*/)
                  },
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v17/*: any*/),
                  (v32/*: any*/)
                ]
              },
              (v33/*: any*/),
              (v34/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v35/*: any*/),
        "concreteType": "ContentContributors",
        "kind": "LinkedField",
        "name": "contentContributors",
        "plural": false,
        "selections": [
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v24/*: any*/)
          }
        ]
      },
      (v39/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentHeaderUnifiedQuery",
    "selections": [
      {
        "args": (v9/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v19/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v40/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v40/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "lastOwnedBy",
                    "plural": false,
                    "selections": (v40/*: any*/)
                  }
                ]
              },
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": (v40/*: any*/)
                  },
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v17/*: any*/),
                  (v32/*: any*/)
                ]
              },
              (v33/*: any*/),
              (v34/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v35/*: any*/),
        "concreteType": "ContentContributors",
        "kind": "LinkedField",
        "name": "contentContributors",
        "plural": false,
        "selections": [
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v40/*: any*/)
          }
        ]
      },
      (v39/*: any*/)
    ]
  },
  "params": {
    "cacheID": "0e2ff3e32406276d823f5080dc7f9714",
    "id": "54a10e60e2a0c15ce92471d6e08870349218fb356a74754f5961430a595b415b",
    "metadata": {},
    "name": "ContentHeaderUnifiedQuery",
    "operationKind": "query",
    "text": "query ContentHeaderUnifiedQuery($contentId:ID!,$spaceKey:String,$versionOverride:Int,$embeddedContentRender:String,$limit:Int,$useNewContentTopper:Boolean=false,$isMarkdownModeEnabled:Boolean=false,$status:[String]){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender,status:$status){nodes{id,type,subType,title,status,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},space{id,name,homepageId},version{message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy,isMarkdownMode@include(if:$isMarkdownModeEnabled)}},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}}}},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}}"
  }
};
})();

(node as any).hash = "bcaab4c549f5b087cf1d5719eca13fdc";

export default node;
